import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { ChangePasswordModel } from "@obg/ngx.common/types";
import { AUTH_MESSAGE_CODES, AppError, MessageScopeType, MessageService, MessageType } from "@obg/ngx.core";
import { merge, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ACCOUNT_SETTINGS_ACTION_TYPE, AccountSettingsAction } from "./account-settings.action";
import { ACCOUNT_SETTINGS_MESSAGE_CONTEXT } from "./account-settings.const";
import { AccountSettingsService } from "./account-settings.service";

@Injectable()
/**
 * @deprecated - [fabric-deprecated] - Use AccountSettingsService from app-account mfe instead
 */
export class AccountSettingsEffect {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand_INTERNAL.ChangePassword) instead
	 */
	changePassword$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ACCOUNT_SETTINGS_ACTION_TYPE.changePassword),
			map((x: ActionWithPayload<ChangePasswordModel>) => x.payload),
			switchMap((model) =>
				this.service.changePassword(model).pipe(
					map(() => this.action.changePasswordSuccess()),
					catchError((error: AppError) => of(this.action.changePasswordFail(error)))
				)
			)
		)
	);
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand_INTERNAL.ChangePassword) instead
	 */
	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$({
				[ACCOUNT_SETTINGS_ACTION_TYPE.changePasswordFail]: ACCOUNT_SETTINGS_MESSAGE_CONTEXT.changePassword,
			}),
			this.messageService.mapClearByContext$({
				[ACCOUNT_SETTINGS_ACTION_TYPE.changePassword]: ACCOUNT_SETTINGS_MESSAGE_CONTEXT.changePassword,
			}),
			this.messageService.map$({
				[ACCOUNT_SETTINGS_ACTION_TYPE.changePasswordSuccess]: {
					context: ACCOUNT_SETTINGS_MESSAGE_CONTEXT.changePassword,
					scope: MessageScopeType.Local,
					type: MessageType.Success,
					messageCode: AUTH_MESSAGE_CODES.changePassword.success,
				},
			})
		)
	);

	constructor(
		private actions$: Actions,
		private action: AccountSettingsAction,
		private service: AccountSettingsService,
		private messageService: MessageService
	) {}
}
